;(function() {
  'use strict'

  angular.module('core.manageKits', [])
})()
